<template>
  <div>
    <AIChatbot />
  </div>
</template>

<script>
import AIChatbot from 'component-ai-chatbot'
export default {
  name: 'WebsiteChatbot',
  components: {
    AIChatbot,
  },
}
</script>

<style scoped>
body {
  height: fit-content;
}
</style>
